export interface NavLink {
  label: string
  href: string
}

export interface NavGroup {
  label: string
  href: string
  links: NavLink[]
}

export const navGroups: NavGroup[] = [
  {
    label: 'Products',
    href: '/products/',
    links: [
      { label: 'Overview', href: '/products/' },
      { label: 'Starter Kits', href: '/products/starter-kits/' },
      { label: 'Tool Holders', href: '/products/holders/' },
      { label: 'Inserts & Chipbreakers', href: '/products/inserts/' },
      { label: 'Accessories', href: '/products/accessories/' },
    ],
  },
  {
    label: 'Applications',
    href: '/applications/',
    links: [
      { label: 'Overview', href: '/applications/' },
      { label: 'Aluminum', href: '/applications/aluminum/' },
      {
        label: 'Copper & Soft Alloys',
        href: '/applications/copper-soft-alloys/',
      },
      { label: 'Titanium', href: '/applications/titanium/' },
    ],
  },
  {
    label: 'Technical Resources',
    href: '/technical-resources/',
    links: [
      { label: 'Overview', href: '/technical-resources/' },
      { label: 'Starting Data', href: '/technical-resources/starting-data/' },
      { label: 'Tool Selection', href: '/technical-resources/tool-selection/' },
      { label: 'Workholding & Safety', href: '/technical-resources/safety/' },
    ],
  },
]

export const topLevelLinks: NavLink[] = [
  { label: 'About', href: '/about/' },
  { label: 'Contact', href: '/contact/' },
]

export const footerGroups: { label: string; links: NavLink[] }[] = [
  {
    label: 'Products',
    links: [
      { label: 'Starter Kits', href: '/products/starter-kits/' },
      { label: 'Tool Holders', href: '/products/holders/' },
      { label: 'Inserts & Chipbreakers', href: '/products/inserts/' },
      { label: 'Accessories', href: '/products/accessories/' },
    ],
  },
  {
    label: 'Applications',
    links: [
      { label: 'Aluminum', href: '/applications/aluminum/' },
      {
        label: 'Copper & Soft Alloys',
        href: '/applications/copper-soft-alloys/',
      },
      { label: 'Titanium', href: '/applications/titanium/' },
    ],
  },
  {
    label: 'Resources',
    links: [
      { label: 'Technical Resources', href: '/technical-resources/' },
      { label: 'Starting Data', href: '/technical-resources/starting-data/' },
      { label: 'Tool Selection', href: '/technical-resources/tool-selection/' },
      { label: 'Workholding & Safety', href: '/technical-resources/safety/' },
    ],
  },
  {
    label: 'Company',
    links: [
      { label: 'About', href: '/about/' },
      { label: 'Contact', href: '/contact/' },
    ],
  },
]

export const CONTACT = {
  phoneLabel: '800-397-7745',
  phoneHref: 'tel:+18003977745',
  techPhoneLabel: '650-224-7511',
  techPhoneHref: 'tel:+16502247511',
  techAssistSentence:
    'The Shear Geometry technical staff will gladly help you with your application.',
  email: 'sales@sheargeometry.com',
  emailHref: 'mailto:sales@sheargeometry.com',
  mailingAddress: '325 Sharon Park Drive, Unit #444, Menlo Park, CA 94025',
}

/** What to have ready before calling technical assistance. */
export const techPrepList = [
  'Material, alloy and condition',
  'Machine model and horsepower',
  'Workholding and jaw engagement',
  'Holder size',
  'Intended depth of cut and feed',
  'Chip-control goal',
]
